__turbopack_context__.v({
  "bar": "employee-hours-visual-module__cSCNoG__bar",
  "card": "employee-hours-visual-module__cSCNoG__card",
  "root": "employee-hours-visual-module__cSCNoG__root",
});
